import React, { useEffect, useState } from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import styles from "../RawData/Header/Header.module.sass";
import {
    SovosToolbar,
    SovosToolbarActions,
    SovosMenuItem,
    SovosToolbarDropdown,
    SovosBox,
    SovosTypography,
} from "mosaic-react";
import HeaderEditMode from "../RawData/Header/HeaderEditMode";

const CustomCsvRawDataHeader = (props) => {
    const {
        getCustomCsvTablesAvailable,
        title,
        editMode,
        setEditMode,
        onClickSave,
        list,
        rawDataEdit,
    } = props;

    const { history, params, i18n } = useGlobalValue();
    const { projectId, modulePrefix, fiscalYear, entityRawData } = params;
    const [arrayImportIds, setArrayImportIds] = useState([]);
    const [currentFile, setCurrentFile] = useState(entityRawData || "");

    useEffect(() => {
        getCustomCsvTablesAvailable(projectId, modulePrefix)
            .then((res) => {
                const { custom_csv_tables_available } = res;
                setArrayImportIds(custom_csv_tables_available || []);
            })
            .catch((error) => console.error(error));
    }, [projectId, modulePrefix, fiscalYear, getCustomCsvTablesAvailable]);

    // Auto-select first table if available and no entity is selected
    useEffect(() => {
        if (arrayImportIds?.length > 0 && !entityRawData) {
            const firstTable = arrayImportIds[0];
            setCurrentFile(firstTable);
            const myRegex =
                /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/(\d+|full)\/(.*\/)?(\/*.*)/;
            const newHistory = history.location.pathname.replace(
                myRegex,
                `$1$3/$4/$5${firstTable}`,
            );
            history.push(newHistory);
        }
    }, [arrayImportIds, entityRawData, history]);

    return (
        <div key="mainDiv">
            <div className={`${styles["header-root"]}`}>
                <SovosBox
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginLeft: "24px",
                        marginRight: "24px",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        borderBottom: "1px solid rgb(219, 224, 229)",
                    }}
                >
                    <SovosTypography variant={"h4"}>{title}</SovosTypography>
                    <HeaderEditMode
                        editMode={editMode}
                        setEditMode={setEditMode}
                        onClickSave={onClickSave}
                        params={params}
                        list={list}
                        rawDataEdit={rawDataEdit}
                    />
                </SovosBox>

                <div className={`${styles["toolbar-container"]}`}>
                    <SovosToolbar className={`${styles["sovos-toolbar"]}`}>
                        <SovosToolbarActions className={`${styles["toolbar-actions"]}`}>
                            <SovosToolbarDropdown
                                className={`${styles["toolbar-dropdown"]}`}
                                value={
                                    (arrayImportIds || []).includes(currentFile)
                                        ? currentFile
                                        : entityRawData || ""
                                }
                                onChange={(event) => {
                                    setCurrentFile(event.target.value);
                                    const myRegex =
                                        /^(\/(pt|en|lt|es|ro|fr)\/\d+\/)(\d{4}|current)\/(\d+|full)\/(.*\/)?(\/*.*)/;
                                    const tableName = event.target.value.trim();
                                    const newHistory = history.location.pathname.replace(
                                        myRegex,
                                        `$1$3/$4/$5${tableName}`,
                                    );
                                    history.push(newHistory);
                                }}
                            >
                                {arrayImportIds?.length ? (
                                    arrayImportIds.map((name) => (
                                        <SovosMenuItem key={name} value={name}>
                                            {name}
                                        </SovosMenuItem>
                                    ))
                                ) : (
                                    <SovosTypography sx={{ padding: "5px" }}>
                                        {i18n`No options available`}
                                    </SovosTypography>
                                )}
                            </SovosToolbarDropdown>
                        </SovosToolbarActions>
                    </SovosToolbar>
                </div>
            </div>
        </div>
    );
};

export default CustomCsvRawDataHeader;
